import { CircleHelp, ClipboardList, LayoutDashboard, Receipt } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext'
import AppShell from './AppShell'

export default function LayoutCliente({ children }) {
  const { user } = useAuth()
  const admin = (user?.role_cliente || 'comum') === 'administrador'
  const navItems = [
    { to: '/', icon: LayoutDashboard, label: 'Meu painel' },
    { to: '/chamados', icon: ClipboardList, label: admin ? 'Todos os chamados' : 'Meus chamados' },
    { to: '/ajuda', icon: CircleHelp, label: 'Central de ajuda' },
    ...(admin ? [{ to: '/fechamento', icon: Receipt, label: 'Faturas', section: 'Financeiro' }] : []),
  ]
  return <AppShell navItems={navItems} roleLabel={admin ? 'Administrador do cliente' : 'Cliente'} contentWidth="standard" showNotifications>{children}</AppShell>
}
